import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import { IdeapoolAddPage } from "../ideapool-add/ideapool-add";

/**
 * Generated class for the IdeapoolPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ideapool',
  templateUrl: 'ideapool.html',
})
export class IdeapoolPage {
  title: string = 'Ideen & Vorschläge';
  ideas: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public modalCtrl: ModalController, public teamappProvider: TeamappProvider) {
      if(this.navParams.get("title")) {
          this.title = this.navParams.get("title");
      }
      this.loadIdeas();
  }

  loadIdeas()  {
      this.teamappProvider.http_request('action=get_ideas', 'idea', false, true).then(data => {
          let ideaData: any = data;
          if(!ideaData.error) {
              this.ideas = ideaData;
          }
      });
  }

  onLikeItem(item: any) {
    this.teamappProvider.http_request('action=vote&vote_id='+item.id+'&vote_state=1', 'idea', false, true).then(data => {
      if(data) {
          item.likes += 1;
          item.deleted = true;
          setInterval( () => {
              item.disabled = true;
          }, 750);
      }
    });
  }

  onDislikeItem(item: any) {
    this.teamappProvider.http_request('action=vote&vote_id='+item.id+'&vote_state=2', 'idea', false, true).then(data => {
      if(data) {
          item.dislikes += 1;
          item.deleted = true;
          setInterval( () => {
              item.disabled = true;
          }, 750);
      }
    });
  }

  refreshIdeas(refresher:any) {
    this.teamappProvider.http_request('action=get_ideas', 'idea', false, false).then(data => {
        refresher.complete();
        let ideaData: any = data;
        if(!ideaData.error) {
          this.ideas = ideaData;
        }
    });
  }

  onResetItem(item:any) {
    this.teamappProvider.http_request('action=reset&vote_id='+item.id, 'idea', false, true).then(data => {
      if(data) {
          this.loadIdeas();
      }
    });
  }

  addIdea() {
      let profileModal = this.modalCtrl.create(IdeapoolAddPage);
      profileModal.present();
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad IdeapoolPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/ideapool/ideapool.ts